module.exports = __webpack_public_path__ + "static/img/ddz-03.6002da58.jpg";